import { type ReactNode } from 'react';

export function highlightMatch(text: string, query: string): ReactNode {
  if (!query) return text;
  const idx = text.toLowerCase().indexOf(query.toLowerCase());
  if (idx < 0) return text;
  const before = text.slice(0, idx);
  const match = text.slice(idx, idx + query.length);
  const after = text.slice(idx + query.length);
  return (
    <>
      {before}
      <mark style={{ background: 'rgb(255, 243, 163)', padding: 0 }}>{match}</mark>
      {after}
    </>
  );
}
